import { Badge } from "@/components/ui/badge";
import {
  NUMBER_REQUEST_STEPS,
  type NumberRequestState,
} from "@/features/number-requests/types";
import { useTranslation } from "@/features/utils/i18n";

/**
 * Colour carries the only thing a glance needs: is this moving, done, or dead.
 * The step number is what tells the client how far along it is — a state name
 * alone ("submitted") says nothing about how much is left.
 */
const VARIANTS: Record<
  NumberRequestState,
  "default" | "secondary" | "destructive" | "outline"
> = {
  draft: "outline",
  documents_pending: "secondary",
  documents_review: "secondary",
  submitted: "secondary",
  approved: "default",
  provisioned: "default",
  rejected: "destructive",
  cancelled: "outline",
};

export function NumberRequestStateBadge({
  state,
}: {
  state: NumberRequestState;
}) {
  const { t } = useTranslation("numberRequests");
  const index = NUMBER_REQUEST_STEPS.indexOf(state);

  return (
    <div className="flex items-center gap-2">
      <Badge variant={VARIANTS[state]}>
        {t(`numberRequests.states.${state}`)}
      </Badge>
      {index >= 0 && state !== "provisioned" && (
        <span className="text-xs text-muted-foreground">
          {t("numberRequests.stepCount", {
            current: index + 1,
            total: NUMBER_REQUEST_STEPS.length,
          })}
        </span>
      )}
    </div>
  );
}
